module.exports = __webpack_public_path__ + "static/media/Site1.b5782d4b.jpeg";